
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import CategorySelect from "@/components/CategorySelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import { Getter } from "vuex-class";
import {
getActivityTraceRealTimePopularityDrawWriteOffDateDtl
} from "@/api/shouyin";
import { callPhone } from '@/utils/h5ToApp'

@Component({
  components: { CategorySelect, DimensionSelect, SearchPopup, CustomTable },
})
export default class WinningVerifyDetail extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter companyId!: string;
  params: Record<string, any> = {};
  isInit = false;
  searchRes = null;
  lotteryId = ''
  columnsScroll = [
    {
      key: "winUserName",
      title: "中奖人名称",
      width: "120",
      // textOverflow: "ellipsis",
      // fixed: 'left'
    },
    {
      key: "prizeName",
      title: "奖品名称",
      align: "left",
      textOverflow: "auto",
      // dataType: "amount",
      order: "",
    },
    {
      key: "getTime",
      title: "中奖时间",
      align: "left",
      // width: "106",
      sort: true,
      // dataType: "amount",
    },
    {
      key: "writeOffTime",
      title: "核销时间",
      align: "left",
      sort: true,
      // dataType: "amount",
    }
  ];
  tableDataSource = [];

  @Watch("params", { deep: true })
  onParamsChange() {
    this.getActivityTraceRealTimePopularityDrawWriteOffDateDtl();
  }

  orderByColumn(item: any) {
    console.log(item.key, item.order);
    // asc 生序 desc 降序 getTime 中奖时间  writeOffTime  核销时间
    // sort（1 中奖升序 2 中奖降序 3 核销升序 4 核销降序）
    if(item.key ==='getTime'){
      this.params.sort = item.order === "asc" ? 1 : 2;
    } else if (item.key ==='writeOffTime') {
      this.params.sort = item.order === "asc" ? 3 : 4;
    }
    this.getActivityTraceRealTimePopularityDrawWriteOffDateDtl();
  }
  mounted() {
    this.lotteryId = this.$route.query.lotteryId as string;
    this.getActivityTraceRealTimePopularityDrawWriteOffDateDtl()
  }

  getActivityTraceRealTimePopularityDrawWriteOffDateDtl(){
    this.isInit = false;
    getActivityTraceRealTimePopularityDrawWriteOffDateDtl({
      lotteryId: this.lotteryId,
      // lotteryId: '69d723c346565648a10963a4',
      storeId: this.companyId,
      ...this.params
    }).then((res: any) => {
      this.tableDataSource = res.data
      this.isInit = true;
    })
  }

  makePhoneCall (phoneNumber: string) {
    callPhone({ tel: phoneNumber })
  }
}
